import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang, useRouter, useEffect, useState, Link, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const { locale } = useRouter();
    const [open, setOpen] = useState(false);
    const LOCAL_SITES: string[] = ['jp'];
    const cards: any[] = [
        {
            subtitle: t('secB_card1_subtitle'),
            title: t('secB_card1_title'),
            desc: t.rich('secB_card1_desc', {
                n: (text: string) => <span className="no-wrap">{text}</span>,
                t: (text: string) => <span className="tip">{text}</span>,
            }),
            img: `/responsive/picture/delta-pro-ultra/prelaunch/2_1${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        },
        {
            subtitle: t('secB_card2_subtitle'),
            title: t('secB_card2_title'),
            desc: t.rich('secB_card2_desc', {
                sub: (text: any) => <sup>{text}</sup>,
                n: (text: string) => <span className="no-wrap">{text}</span>,
                t: (text: string) => <span className="tip">{text}</span>,
            }),
            img: `/responsive/picture/delta-pro-ultra/prelaunch/2_2${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        },
        {
            subtitle: t('secB_card3_subtitle'),
            title: t('secB_card3_title'),
            desc: t.rich('secB_card3_desc', {
                sub: (text: any) => <sup>{text}</sup>,
                n: (text: string) => <span className="no-wrap">{text}</span>,
                t: (text: string) => <span className="tip">{text}</span>,
            }),
            img: `/responsive/picture/delta-pro-ultra/prelaunch/2_3${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        },
        {
            subtitle: t('secB_card4_subtitle'),
            title: t('secB_card4_title'),
            desc: t.rich('secB_card4_desc', {
                n: (text: string) => <span className="no-wrap">{text}</span>,
            }),
            img: `/responsive/picture/delta-pro-ultra/prelaunch/2_4${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        },
    ];

    return (
        <div id="delta-pro-ultra-prelaunch-B" className={`delta-pro-ultra-B ${css['delta-pro-ultra-B']}`}>
            <div className="ef-box">
                <div className={`text-box ${open ? 'open' : 'close'}`}>
                    <p className="title">
                        {t.rich('secB_title', {
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                    <p className="desc">
                        {t.rich('secB_desc', {
                            s: (text: string) => <span className="s">{text}</span>,
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                    <p className="text text1">
                        <span className="text-inner">
                            {t.rich('secB_text1', {
                                s: (text: string) => <span className="s">{text}</span>,
                                n: (text: string) => <span className="no-wrap">{text}</span>,
                            })}
                        </span>
                        <span className="text-icon" onClick={() => setOpen(!open)}>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.9">
                                    <rect width="17" height="17" rx="8.5" fill="#E1E1E1" />
                                    <path
                                        d="M4.5 6.9209L8.5 10.9209L12.5 6.9209"
                                        stroke="#9A9A9A"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                        </span>
                    </p>
                    <p className="text text2">
                        {t.rich('secB_text2', {
                            s: (text: string) => <span className="s">{text}</span>,
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                </div>
                <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-img left-img">
                                <EFPicture src={card?.img} alt={card?.title} />
                            </div>
                            <div className="card-info">
                                <h4 className="card-subtitle">{card?.subtitle}</h4>
                                <h3 className="card-title">{card?.title}</h3>
                                <p className="card-desc">{card?.desc}</p>
                            </div>
                            <div className="card-img right-img">
                                <EFPicture src={card?.img} alt={card?.title} />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
